import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { DealSearchService } from './deal-search.service';
import { FormControl, Validators } from '@angular/forms';
import { debounceTime, Subscription } from 'rxjs';
import Project from '../../../interfaces/project';
import { MatOption } from '@angular/material/core';

@Component({
    selector: 'deal-search',
    templateUrl: './deal-search.component.html',
    styleUrls: ['./deal-search.component.scss'],
    providers: [DealSearchService],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DealSearchComponent {
  @Input() required = false;
  @Input() deal: Project | null = null;
  @Input() control = new FormControl<Project | string | null>(this.deal ?? '');
  @Input() disabled = false;
  private controlSub: Subscription;

  @Output() dealChange = new EventEmitter<Project | null | undefined>();
  constructor(public dealSearch: DealSearchService) {}
  displayFn(project: Project) {
    return project && project.name ? project.name : '';
  }
  optionSelected(option: MatOption<any>) {
    let deal = option.value as unknown as Project | null;
    if (deal?.id !== this.deal?.id) {
      this.deal = deal;
      this.control.setValue(this.deal);
      this.dealChange.emit(this.deal);
    }
  }
  ngOnInit() {
    if (this.required) {
      this.control.addValidators(Validators.required);
    }
    this.controlSub = this.control.valueChanges
      .pipe(debounceTime(500))
      .subscribe((value) => {
        if (typeof value === 'string' && value.length) {
          this.dealSearch.searchForDeal(value);
        } else if (typeof value === 'string' && value.length === 0) {
          this.dealSearch.clearOptions();
          this.deal = null;
          this.dealChange.emit(this.deal);
        } else if (typeof value !== 'string') {
          this.deal = value;
          this.dealChange.emit(this.deal);
        }
      });
  }
  ngOnDestroy() {
    this.controlSub?.unsubscribe();
  }
}
